import {
  FD_TICKET,
  CREATE_FD_RESULT,
  GET_VIEW_FD
} from "./type";

const initalState = {
  fdTicketLists: {},
  createFdResult:{},
  fdTicketDetails:{}
};

const FreshdeskReducer = (state = initalState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FD_TICKET:
      return {
        ...state,
        fdTicketLists: payload,
      };
    case CREATE_FD_RESULT:
      return {
        ...state,
        createFdResult: payload,
      };
    case GET_VIEW_FD:
      return {
        ...state,
        fdTicketDetails: payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default FreshdeskReducer;
